// Reads the canonical `{ status, error_code, message, meta? }` envelope off an
// axios error. Endpoints not yet backfilled to the envelope still return a
// legacy `{ message }` (or `{ error }`) shape, so this helper falls back to
// those without forcing every caller to reach into `error.response.data`.
export function readErrorEnvelope(error) {
  const data = error?.response?.data ?? {};
  const message = data.message ?? data.error ?? error?.message ?? 'Something went wrong. Please try again.';

  return {
    errorCode: data.error_code ?? null,
    message,
    meta: data.meta ?? {},
    status: error?.response?.status ?? null,
  };
}
